import React from 'react';
import Stack from 'atoms/Layout/Stack/Stack';
import HeadingAndSupportingText from 'molecules/HeadingAndSupportingText/HeadingAndSupportingText';

const WhyMightyTextBlock = (): JSX.Element => (
  <Stack
    margin={['spacing-none', 'spacing-auto']}
    maxWidth='width-fit-content'
  >
    <HeadingAndSupportingText
      heading={{
        type: 'heading',
        size: 'xl',
        fontWeight: 'font-weight-semibold',
        letterSpacing: -1,
        textAlign: 'center',
        text: 'Why Mighty Works',
      }}
      supportingText={{
        type: 'paragraph',
        size: 'xl',
        color: 'text-tertiary',
        textAlign: 'center',
        text: "Most platforms sell more features. Here's what actually matters.",
      }}
      gap='spacing-3xl'
    />
  </Stack>
);

export default WhyMightyTextBlock;
